var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 13.8337C5.83333 13.3753 6.20833 13.0003 6.66667 13.0003C7.125 13.0003 7.5 13.3753 7.5 13.8337C7.5 14.292 7.125 14.667 6.66667 14.667C6.20833 14.667 5.83333 14.292 5.83333 13.8337ZM10 13.0003H13.3333C13.7917 13.0003 14.1667 13.3753 14.1667 13.8337C14.1667 14.292 13.7917 14.667 13.3333 14.667H10C9.54167 14.667 9.16667 14.292 9.16667 13.8337C9.16667 13.3753 9.54167 13.0003 10 13.0003ZM15 17.167H5C4.54083 17.167 4.16667 16.7928 4.16667 16.3337V11.3337H15.8333V16.3337C15.8333 16.7928 15.4592 17.167 15 17.167ZM5 5.50033H5.83333V6.33366C5.83333 6.79199 6.20833 7.16699 6.66667 7.16699C7.125 7.16699 7.5 6.79199 7.5 6.33366V5.50033H12.5V6.33366C12.5 6.79199 12.875 7.16699 13.3333 7.16699C13.7917 7.16699 14.1667 6.79199 14.1667 6.33366V5.50033H15C15.4592 5.50033 15.8333 5.87449 15.8333 6.33366V9.66699H4.16667V6.33366C4.16667 5.87449 4.54083 5.50033 5 5.50033ZM15 3.83366H14.1667V3.00033C14.1667 2.54199 13.7917 2.16699 13.3333 2.16699C12.875 2.16699 12.5 2.54199 12.5 3.00033V3.83366H7.5V3.00033C7.5 2.54199 7.125 2.16699 6.66667 2.16699C6.20833 2.16699 5.83333 2.54199 5.83333 3.00033V3.83366H5C3.62167 3.83366 2.5 4.95533 2.5 6.33366V16.3337C2.5 17.712 3.62167 18.8337 5 18.8337H15C16.3783 18.8337 17.5 17.712 17.5 16.3337V6.33366C17.5 4.95533 16.3783 3.83366 15 3.83366Z",
    fill: "#434656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.74e33e0832464ad471218c569933c103.svg";
export { ForwardRef as ReactComponent };